import { gql } from "__generated__/gql";
import { useAdminQuery } from "utils/apollo/hooks/admin";
import { assertPresence } from "utils/assertions";
import ReverseMappings from "components/Shared/ReverseMappings";
import {
  ADMIN_ANALYTICS_RETAILER_MAPPING,
  adminAnalyticsRetailerMappingPage,
} from "utils/links";

const query = gql(/* GraphQL */ `
  query RetailerReverseMappings($retailerId: UUID!) {
    dataSourceTypeRetailerMappingsList(
      condition: { retailerId: $retailerId }
      orderBy: CREATED_AT_ASC
    ) {
      id
      columnValue {
        id
        ...ReverseMappingsFragment
      }
    }
  }
`);

type Props = {
  retailerId: UUID;
};

export default function RetailerMappings({ retailerId }: Props) {
  const { data, loading } = useAdminQuery(query, {
    variables: { retailerId },
    fetchPolicy: "cache-and-network",
  });

  return (
    <ReverseMappings
      columnValues={data?.dataSourceTypeRetailerMappingsList?.map((m) => {
        assertPresence(m.columnValue);
        return m.columnValue;
      })}
      getMappingPageLinkForType={(dst) =>
        `${adminAnalyticsRetailerMappingPage(
          dst,
        )}&mapping__retailer__retailer=${retailerId}`
      }
      isLoading={loading}
      mappingPageLink={ADMIN_ANALYTICS_RETAILER_MAPPING}
    />
  );
}
